import { render, staticRenderFns } from "./SettingsPart.vue?vue&type=template&id=6d8dc65c&scoped=true"
import script from "./SettingsPart.vue?vue&type=script&lang=js"
export * from "./SettingsPart.vue?vue&type=script&lang=js"
import style0 from "./SettingsPart.vue?vue&type=style&index=0&id=6d8dc65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8dc65c",
  null
  
)

export default component.exports